// extracted by mini-css-extract-plugin
export var bottom = "touchpoint-button-module--bottom--5d78a";
export var button = "touchpoint-button-module--button--0a7e5";
export var buttonContainer = "touchpoint-button-module--buttonContainer--e70a6";
export var customer = "touchpoint-button-module--customer--a75c4";
export var desc = "touchpoint-button-module--desc--7bbca";
export var descName = "touchpoint-button-module--descName--c1801";
export var description = "touchpoint-button-module--description--9b095";
export var descriptionTop = "touchpoint-button-module--descriptionTop--9466d";
export var employee = "touchpoint-button-module--employee--211bf";
export var first = "touchpoint-button-module--first--82ea1";
export var last = "touchpoint-button-module--last--71dc0";
export var logo = "touchpoint-button-module--logo--34b23";
export var name = "touchpoint-button-module--name--70c56";
export var nameContainer = "touchpoint-button-module--nameContainer--26cad";
export var top = "touchpoint-button-module--top--15094";